import { getSintegradaServerApi } from "@/services/api";
import { InternalDepartmentParams } from "@/@types/sintegrada/InternalDepartmentParams";
import { ResumeGrouped } from "@/services/esus/attendanceService";

type DepartmentResumeParams = InternalDepartmentParams & {
	department: number;
};

export type InternalDepartmentResume = {
	department: ResumeGrouped<string, object>[];
};

export async function getInternalDepartmentResume({ ...params }: DepartmentResumeParams) {
	const url = `/Occupation/internal-departments-resume`;

	const { data } = await getSintegradaServerApi().get<InternalDepartmentResume>(url, params);

	return data || ({} as InternalDepartmentResume);
}
